import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/** Restore history entries and resolve anchors after the destination route commits. */
export const ScrollToLocation = () => {
  const { pathname, hash, key } = useLocation();
  const navigationType = useNavigationType();
  const positions = useRef(new Map<string, { top: number; left: number }>());

  useEffect(() => {
    const saved = navigationType === "POP" ? positions.current.get(key) : undefined;
    const savePosition = () => {
      positions.current.set(key, { top: window.scrollY, left: window.scrollX });
    };
    const frame = window.requestAnimationFrame(() => {
      if (saved) {
        window.scrollTo({ ...saved, behavior: "instant" });
      } else if (hash) {
        document.getElementById(hash.slice(1))?.scrollIntoView({ block: "start" });
      } else if (navigationType !== "POP") {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      }
      savePosition();
    });

    // Record scrolling while this entry is active. Reading on route cleanup can
    // capture a position already clamped by the next page's shorter content.
    window.addEventListener("scroll", savePosition, { passive: true });
    return () => {
      window.cancelAnimationFrame(frame);
      window.removeEventListener("scroll", savePosition);
    };
  }, [pathname, hash, key, navigationType]);
  return null;
};
